<template>
  <v-container class="px-0 pt-3 pb-0">
      <v-row class="ma-0">
        <v-col class="float-right px-0 pb-0 pt-4" cols="12" sm="12" md="12">
            <v-row class="ma-0">
            <v-spacer />
              <v-btn
                outlined
                height="30px"
                small
                color="primary"
                depressed
                class="px-2 ml-2"
                @click="refresh"
              >Atualizar dados</v-btn>

              <v-btn
                v-if="downloadShow"
                outlined
                height="30px"
                small
                color="primary"
                depressed
                class="px-2 ml-2"
                :disabled="!downloadValid"
                @click="downloadCapalote"
              >Download capa de lote</v-btn>

              <v-btn
                v-show="protocoloEmMassaBtn && protocoloAlocado && !!parameter && !parameter.FAT_ENVIO_OPERADORA && info.status!='F'"
                v-if="userData.PermissaoAcoes.faturamento.includes('updateprotocolo')"
                outlined
                small
                height="30px"
                color="primary"
                depressed
                class="px-2 ml-2"
               @click="protocoloEmMassa"
              >Protocolo em massa</v-btn>
              <v-tooltip v-else center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                  small
                  outlined
                  color="rgb(151 151 151 / 58%)"
                  height="30px"
                  class="px-2 ml-2"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  >Protocolo em massa</v-btn>
                </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                  Você não possui permissão para executar esta ação.
                </span>
              </v-tooltip>
              <v-tooltip v-if="protocoloEmMassaBtn && !protocoloAlocado && parameter && !parameter.FAT_ENVIO_OPERADORA && info.status !='F'" center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                  small
                  outlined
                  color="rgb(151 151 151 / 58%)"
                  height="30px"
                  class="px-2 ml-2"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  >Protocolo em massa</v-btn>
                </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                  Selecione mais de um lote valido para editar os protocolos em massa.
                </span>
              </v-tooltip>
              
              <v-btn
                v-if="hasLotesValidos && parameter && parameter.FAT_ENVIO_OPERADORA && info.status != 'F'"
                outlined
                height="30px"
                small
                color="primary"
                depressed
                class="px-2 ml-2"
                @click="showOpen('liberar_envio')"
              >Transmitir lotes validados</v-btn>
              <!-- <v-btn
              v-if="userData.PermissaoAcoes.faturamento.includes('associarnotafiscal')"
              outlined
              small
              height="30px"
              color="primary"
              depressed
              :disabled="info.qt_arq == 0"
              class="px-2 ml-2"
              @click="showOpen('associar_nota')"
              >Associar nota fiscal</v-btn>
              <v-tooltip v-else center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                  outlined
                  small
                  color="rgb(151 151 151 / 58%)"
                  height="30px"
                  class="px-2 ml-2"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  >Associar nota fiscal</v-btn>
                </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                  Você não possui permissão para executar esta ação.
                </span>
              </v-tooltip> -->
              <v-btn
                v-show="(info.status!='F' || integracao)"
                v-if="userData.PermissaoAcoes.faturamento.includes('addlote')"
                outlined
                small
                height="30px"
                color="primary"
                depressed
                class="px-2 ml-2"
                @click="showOpen('add_lote')"
              >Adicionar lote</v-btn>
              <v-tooltip v-else center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                  small
                  outlined
                  color="rgb(151 151 151 / 58%)"
                  height="30px"
                  class="px-2 ml-2"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  >Adicionar lote</v-btn>
                </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                  Você não possui permissão para executar esta ação.
                </span>
              </v-tooltip>
              <v-btn
              v-show="info.status!='F'"
              v-if="userData.PermissaoAcoes.faturamento.includes('deletelote')"
              outlined
              small
              height="30px"
              color="primary"
              depressed
              :disabled="lotesSelectList.length == 0"
              class="px-2 ml-2"
              @click="showOpen('delete_lote')"
              >Excluir lote</v-btn>
              <v-tooltip v-else center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                  outlined
                  small
                  color="rgb(151 151 151 / 58%)"
                  height="30px"
                  class="px-2 ml-2"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  >Excluir lote</v-btn>
                </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                  Você não possui permissão para executar esta ação.
                </span>
              </v-tooltip>
              <v-btn
                v-show="mostraRelação"
                v-if="true"
                outlined
                height="30px"
                small
                color="primary"
                depressed
                :disabled="lotesSelectList.length > 1 || lotesSelectList.length == 0 || lotesSelectList[0].etapa < 20 || lotesSelectList[0].proc_trd_tem_erro == 1 || lotesSelectList[0].env_op_tem_erro == 1"
                class="px-2 ml-2"
                @click="relaGuias(lotesSelectList[0])"
              >Relação de guias</v-btn>
            </v-row>
          </v-col>
      </v-row>
      <v-row class="ma-0">
          <v-col class="px-0 py-0" cols="12" sm="12" md="3">
                <h1>Lotes - <span style="font-size:18px">envio {{statusEnvio[paramEnvio]}}</span>
                  <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary" 
                          icon
                          small
                          @click=listaModal()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda</span>
                        </v-tooltip>
                  </span></h1>
                <p>Inclua quantos lotes forem necessários no cronograma antes de concluir.</p>
          </v-col>
      </v-row>
      <v-row class="ma-0">
          <v-col class="px-0 pb-0 mr-2" cols="12" sm="4" md="2" xl="2">
            <v-select
            small
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="formData.etapa"
              flat
              solo
              dense
              height="30px"
              label="Estado"
              :items="items"
              item-text="descricao"
              item-value="id"
              outlined
              @change="filterList(formData);showBtn=true"
            ></v-select>
          </v-col>
          <!-- <v-spacer></v-spacer> -->
          <v-col class="px-0 pb-0" cols="12" sm="6" md="5" xl="4">
            <v-text-field
              v-model="formData.search"
              small
              height="30px"
              prepend-inner-icon="mdi-magnify"
              placeholder="Filtre por nota fiscal, lote, ident. prestador ou nome do arquivo"
              single-line
              outlined
              dense
              hide-details
              @keyup="filterList(formData)"
            ></v-text-field>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      
      formData:{
        etapa: null,
        com_pendencia: null,
        search: null,
      },
      qtdFiles: 0,
      showUpload: false,
      integracao: false,
      items:[
        {id: null , descricao: 'Filtre por estado'},
        {id: 1 , descricao: 'Em validação'},
        {id: 2 , descricao: 'Prontos para transmissão'},
        {id: 3 , descricao: 'Erro na validação'},
        {id: 4 , descricao: 'Em transmissão'}, 
        {id: 5 , descricao: 'Transmitido para operadora'},
        {id: 6 , descricao: 'Rejeitado pela operadora'},
        {id: 7 , descricao: 'Aceito pela operadora'},
        {id: 8 , descricao: 'Aguardando capa de lote'},
        {id: 9 , descricao: 'Capa de lote obtida'}
      ],
      paramEnvio: false,
      statusEnvio: {
        true: 'automatico',
        false: 'manual'
      },
      mostraRelação: true
    }
  },
  watch:{
    info(val){
      if(val.qt_arq>0){
        this.getList(this.formData)
      }
    },
    parameter(obj) {
      if (obj) {
        this.paramEnvio = obj.FAT_ENVIO_OPERADORA? obj.FAT_ENVIO_OPERADORA : false
        this.integracao = obj.ITG_SDI? obj.ITG_SDI : false
      }
    },
    lotesSelectList() {
      this.mostraRelação = this.lotesSelectList.length? !this.lotesSelectList[0].proc_trd_tem_erro == 1 && !this.lotesSelectList[0].env_op_tem_erro == 1 : false;
    }
  },
  mounted(){
      this.paramEnvio = this.parameter && this.parameter.FAT_ENVIO_OPERADORA? this.parameter.FAT_ENVIO_OPERADORA : false
      this.integracao = this.parameter && this.parameter.ITG_SDI? this.parameter.ITG_SDI : false
  },
  methods: {
    listaModal(){
      let paramModal = {
        type: "tutorial",
        title:"Ajuda",
        message: "Clique no título da ajuda para ver o vídeo explicativo.",
        callback: null,
        btConfirm: { name: "Fechar", show: true },
        listaLink: {
          show: true,
          lista: [
            {  title: "Como postar xmls de faturamento", 
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754272499", title:"Como excluir lotes" })}
            },
            {  title: "Como editar os lotes",
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754272534", title:"Como editar os lotes"})}
            },
            {  title: "Como excluir lotes", 
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754272580", title:"Como excluir lotes" })}
            },
            {  title: "Como preencher o protocolo de envio",
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754272612", title:"Como preencher o protocolo de envio"})}
            },
            {  title: "Como adicionar documentos fiscais e associá-los aos lotes",
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754272649", title:"Como adicionar documentos fiscais e associá-los aos lotes"})}
            },
            {  title: "Como concluir o cronograma",
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754272674", title:"Como concluir o cronograma"})}
            },
          ]
        }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    }
  },
  props: {
    filterList: Function,
    getList: Function,
    hasLotesValidos: Boolean,
    info: Object,
    parameter: Object,
    showOpen: Function,
    total_lotes: Number,
    userData: Object,
    refresh: Function,
    protocoloEmMassa: Function,
    protocoloEmMassaBtn: Boolean,
    protocoloAlocado: Boolean,
    userProtocoloAlocado: String,
    downloadCapalote: Function,
    downloadValid: Boolean,
    downloadShow: Boolean,
    lotesSelectList: Array,
    relaGuias: Function,
  }
  
  
}
</script>